/* EAR PLAN storefront behaviour — vanilla JS, no dependencies. */
(function(){
  var cur0=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
  var nf=new Intl.NumberFormat('en-US',{style:'currency',currency:cur0,minimumFractionDigits:0,maximumFractionDigits:2});
  var money=function(c){return nf.format(c/100);};
  /* ear finder: highlight the ears that need no more than the picked piercing level.
     The other ears stay visible, moved to a clearly separated, muted group (never hidden, never presented as recommended). */
  document.querySelectorAll('[data-ep-finder]').forEach(function(root){
    var grid=root.querySelector('[data-ears-grid]');
    if(!grid)return;
    var cards=[].slice.call(grid.querySelectorAll('[data-level]')),count=root.querySelector('[data-count]');
    var rank={lobes:1,helix:2,full:3},current='',also=null;
    function plural(n){return n+(n===1?' ear':' ears');}
    function reset(){
      cards.sort(function(a,b){return a.dataset.i-b.dataset.i;}).forEach(function(c){grid.appendChild(c);c.classList.remove('is-secondary');var f=c.querySelector('[data-flag]');if(f)f.hidden=true;});
      if(also){also.remove();also=null;}
      grid.removeAttribute('data-filtered');if(count)count.textContent='';
    }
    function apply(pick){
      reset();
      var ok=cards.filter(function(c){return rank[c.dataset.level]<=pick;}),no=cards.filter(function(c){return ok.indexOf(c)<0;});
      grid.setAttribute('data-filtered','');
      ok.concat(no).forEach(function(c){grid.appendChild(c);});
      no.forEach(function(c){c.classList.add('is-secondary');var f=c.querySelector('[data-flag]');if(f)f.hidden=false;});
      if(no.length){also=document.createElement('p');also.className='ep-ears__also';also.textContent='More ears · they need more piercings';grid.insertBefore(also,no[0]);}
      if(count)count.textContent=plural(ok.length)+' for your piercings';
    }
    root.querySelectorAll('[data-pick]').forEach(function(b){
      b.addEventListener('click',function(){
        var same=current===b.dataset.pick;
        root.querySelectorAll('[data-pick]').forEach(function(x){x.setAttribute('aria-pressed','false');});
        if(same){current='';reset();return;}
        current=b.dataset.pick;b.setAttribute('aria-pressed','true');apply(rank[current]);
      });
    });
  });
  /* collection: filter chips (type, zone) and price sort */
  document.querySelectorAll('[data-ep-coll]').forEach(function(root){
    var grid=root.querySelector('[data-grid]');
    if(!grid)return;   // empty collection: no grid, nothing to filter
    var cards=[].slice.call(grid.querySelectorAll('[data-price]'));
    var state={type:'',zone:''},empty=root.querySelector('[data-empty]'),count=root.querySelector('[data-count]');
    function apply(){var n=0;cards.forEach(function(c){
      var okT=!state.type||(c.dataset.type||'').toLowerCase()===state.type.toLowerCase(),okZ=!state.zone||(' '+c.dataset.zones+' ').indexOf(' '+state.zone+' ')>-1;
      c.hidden=!(okT&&okZ);if(okT&&okZ)n++;});
      if(empty)empty.hidden=n>0;if(count)count.textContent=n+(n===1?' piece':' pieces');}
    root.querySelectorAll('[data-filter]').forEach(function(b){b.addEventListener('click',function(){
      var k=b.dataset.filter,v=b.dataset.value;
      root.querySelectorAll('[data-filter="'+k+'"]').forEach(function(x){x.setAttribute('aria-pressed','false')});
      if(state[k]===v){state[k]='';}else{state[k]=v;b.setAttribute('aria-pressed','true');}
      apply();sync();});});
    var sort=root.querySelector('[data-sort]');
    if(sort)sort.addEventListener('change',function(){
      var asc=sort.value==='asc';
      cards.sort(function(a,b){return asc?a.dataset.price-b.dataset.price:b.dataset.price-a.dataset.price;}).forEach(function(c){grid.appendChild(c)});});
    /* deep links: ?type=hoop and ?placement=helix pre-select the matching chip; the URL follows the filters so a view can be shared */
    var qs={type:'type',placement:'zone',zone:'zone'};
    function sync(){if(!window.history||!history.replaceState||!window.URLSearchParams)return;
      var u=new URLSearchParams(location.search);u.delete('zone');['type','placement'].forEach(function(n){u.delete(n);});
      if(state.type)u.set('type',state.type.toLowerCase());if(state.zone)u.set('placement',state.zone);
      var q=u.toString();history.replaceState(null,'',location.pathname+(q?'?'+q:'')+location.hash);}
    if(window.URLSearchParams){var up=new URLSearchParams(location.search);
      Object.keys(qs).forEach(function(n){var v=up.get(n);if(!v)return;var k=qs[n];
        var b=[].slice.call(root.querySelectorAll('[data-filter="'+k+'"]')).filter(function(x){return (x.dataset.value||'').toLowerCase()===v.toLowerCase();})[0];
        if(b){state[k]=b.dataset.value;b.setAttribute('aria-pressed','true');}});}
    apply();
  });
  /* stack cards: price = sum of the pieces' prices, read from the real variants (/products/<handle>.js).
     Same rule as the stack page: cheapest buyable variant of each piece (all variants if none is buyable);
     "From" while any piece offers a choice. Nothing is shown when a piece cannot be read, never a guess. */
  (function(){
    var cards=[].slice.call(document.querySelectorAll('[data-stack-pieces]'));if(!cards.length||!window.fetch)return;
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/',memo={};
    function load(h){return memo[h]||(memo[h]=fetch(root+'products/'+encodeURIComponent(h)+'.js',{headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error(h);return r.json();}));}
    function choice(p){return [1,2,3].some(function(i){var seen={};p.variants.forEach(function(v){if(v['option'+i]!=null)seen[v['option'+i]]=1;});return Object.keys(seen).length>1;});}
    function cheapest(p){var pool=p.variants.filter(function(v){return v.available;});if(!pool.length)pool=p.variants;return Math.min.apply(null,pool.map(function(v){return v.price;}));}
    function fmt(c,cur){var w=c%100===0;return new Intl.NumberFormat('en-US',{style:'currency',currency:cur||'USD',minimumFractionDigits:w?0:2,maximumFractionDigits:w?0:2}).format(c/100);}
    cards.forEach(function(card){
      var el=card.querySelector('[data-stack-price]'),hs=card.dataset.stackPieces.split(',').map(function(x){return x.trim();}).filter(Boolean);
      if(!el||!hs.length)return;
      Promise.all(hs.map(load)).then(function(ps){
        if(ps.some(function(p){return !p||!p.variants||!p.variants.length;}))return;
        var sum=ps.reduce(function(a,p){return a+cheapest(p);},0);
        var o=window.EP_OFFERS||{},n=ps.length,pct=window.EP_PCT?window.EP_PCT(n):0,cur=card.dataset.currency,pre=ps.some(choice)?'From ':'';
        if(pct>0){var disc=Math.round(sum*(100-pct)/100);el.innerHTML='';var w=document.createElement('s');w.className='ep-was';w.textContent=fmt(sum,cur);var nw=document.createElement('span');nw.className='ep-now';nw.textContent=' '+pre+fmt(disc,cur);var sv=document.createElement('span');sv.className='ep-savebadge';sv.textContent='Save '+pct+'% · '+fmt(sum-disc,cur);el.appendChild(w);el.appendChild(nw);el.appendChild(sv);}
        else el.textContent=pre+fmt(sum,cur);
        el.hidden=false;
      }).catch(function(){});
    });
  })();
})();
